// extracted by mini-css-extract-plugin
export var arrows = "_3w-6";
export var decrementer = "_3w-a";
export var disabled = "_3w-4";
export var error = "_3w-1";
export var hiddenText = "_3w-b";
export var incrementer = "_3w-9";
export var input = "_3w-8";
export var inputWrapper = "_3w-0";
export var leadingIcon = "_3w-c";
export var readonly = "_3w-3";
export var regular = "_3w-7";
export var small = "_3w-5";
export var warning = "_3w-2";